import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import axios from 'axios';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [companyName, setCompanyName] = useState('Polikap');
  const [companyPhone, setCompanyPhone] = useState('');
  const [logoUrl, setLogoUrl] = useState('/logo.png');
  const [logoHeight, setLogoHeight] = useState(40);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    axios.get('/api/settings').then(r => {
      if (r.data.company_name) setCompanyName(r.data.company_name);
      if (r.data.company_phone) setCompanyPhone(r.data.company_phone);
      if (r.data.logo_url) setLogoUrl(r.data.logo_url);
      if (r.data.logo_height) setLogoHeight(Number(r.data.logo_height));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { to: '/', label: 'Ana Sayfa' },
    { to: '/urunler', label: 'Ürünler' },
    { to: '/hizmetler', label: 'Hizmetler' },
    { to: '/hakkimizda', label: 'Hakkımızda' },
    { to: '/iletisim', label: 'İletişim' },
  ];

  const activeClass = 'text-secondary border-b-2 border-secondary';
  const normalClass = 'text-white/90 hover:text-secondary transition-colors';

  return (
    <nav className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-primary shadow-lg' : 'bg-primary/95 backdrop-blur-sm'}`}>
      {/* Top Bar */}
      <div className="hidden md:block bg-primary-dark text-xs text-gray-300">
        <div className="max-w-7xl mx-auto px-4 py-1.5 flex justify-between items-center">
          <span>Kalite ve Güvenin Adresi</span>
          {companyPhone && (
            <a href={`tel:${companyPhone.replace(/\s/g, '')}`} className="flex items-center gap-1.5 hover:text-secondary transition-colors">
              <FaPhone size={10} /> {companyPhone}
            </a>
          )}
        </div>
      </div>

      {/* Main Nav */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img src={logoUrl} alt={companyName} style={{ height: `${logoHeight}px` }} className="w-auto object-contain group-hover:opacity-90 transition-opacity" />
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-1">
            {links.map(l => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) => `px-4 py-2 text-sm font-medium rounded-md transition-all ${isActive ? 'text-secondary' : 'text-white/90 hover:text-secondary hover:bg-white/10'}`}
              >
                {l.label}
              </NavLink>
            ))}
          </div>

          {/* CTA Button (Desktop) */}
          <div className="hidden md:block">
            <Link to="/iletisim" className="btn-primary text-sm py-2.5 px-5">
              Teklif Alın
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-white p-2 rounded-md hover:bg-white/10 transition-colors"
          >
            {open ? <FaTimes size={20} /> : <FaBars size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-primary-dark border-t border-white/10">
          <div className="px-4 py-3 space-y-1">
            {links.map(l => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) => `block px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${isActive ? 'bg-secondary text-white' : 'text-white/80 hover:bg-white/10 hover:text-white'}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/iletisim" className="block mt-2 btn-primary text-center text-sm">
              Teklif Alın
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
